import { render, staticRenderFns } from "./HeroPictureItem.vue?vue&type=template&id=506de7ff&"
import script from "./HeroPictureItem.vue?vue&type=script&lang=js&"
export * from "./HeroPictureItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports